import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useUnifiedEvent } from '../../contexts/UnifiedEventContext';
import { notificationsService, Notification } from '../../services/firebase/notifications.service';
import { usePermissions } from '../../hooks/usePermissions';
import { Button } from '../../components/shared/Button';

export function NotificationHistoryPage() {
  const { currentUnifiedEvent } = useUnifiedEvent();
  const { isOwner } = usePermissions();
  const [items, setItems] = useState<Notification[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  useEffect(() => {
    let cancelled = false;
    setItems([]); setError('');
    if (!currentUnifiedEvent || !isOwner) { setLoading(false); return; }
    setLoading(true);
    notificationsService.getNotifications(currentUnifiedEvent.id)
      .then(result => { if (!cancelled) setItems(result); })
      .catch(() => { if (!cancelled) setError('Impossible de charger les notifications.'); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [currentUnifiedEvent?.id, isOwner]);
  const markRead = async (id: string) => {
    if (!isOwner) return;
    try {
      await notificationsService.markAsRead(id);
      setItems(previous => previous.map(item => item.id === id ? {...item, read: true} : item));
    } catch { setError('Impossible de mettre à jour la notification.'); }
  };
  return <main className="p-6 space-y-4">
    <h1 className="text-2xl font-semibold">Notifications</h1>
    <Link to="/settings/notifications" className="underline">Préférences des notifications</Link>
    {error && <p role="alert">{error}</p>}
    {loading ? <p role="status">Chargement…</p> : items.length === 0 && <p>Aucune notification pour cet événement.</p>}
    <ul className="space-y-4">{items.map(item => <li key={item.id} className="p-4 border rounded-lg">
      <h2 className="font-medium">{item.title}</h2><p>{item.message}</p>
      {!item.read && <Button onClick={() => void markRead(item.id)}>Marquer comme lu</Button>}
    </li>)}</ul>
  </main>;
}
